import { NgModule } from '@angular/core';
import '@progress/kendo-angular-intl/locales/de/all';
import { CommonModule } from '@angular/common';
import { ProductViewComponent } from './product-view/product-view.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [
    ProductViewComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class ProductsModule { }
